(function () {
  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
      return;
    }

    callback();
  }

  function toggleScrollState() {
    document.body.classList.toggle("bn-scrolled", window.scrollY > 12);
  }

  function initMobileMenu() {
    var header = document.querySelector("[data-site-header]");
    if (!header) return;

    var toggles = Array.prototype.slice.call(header.querySelectorAll("[data-mobile-menu-toggle]"));
    var menu = header.querySelector("[data-mobile-menu]");
    var overlay = header.querySelector("[data-mobile-menu-overlay]");
    var animationFrameId = null;
    var closeTimerId = null;
    var transitionDuration = 340;

    if (!menu || toggles.length === 0) return;

    function syncToggleState(open) {
      header.classList.toggle("is-menu-open", open);
      document.body.classList.toggle("bn-scroll-lock", open);

      toggles.forEach(function (button) {
        button.setAttribute("aria-expanded", open ? "true" : "false");
      });
    }

    function setOpen(open) {
      if (animationFrameId !== null) {
        window.cancelAnimationFrame(animationFrameId);
        animationFrameId = null;
      }

      if (closeTimerId !== null) {
        window.clearTimeout(closeTimerId);
        closeTimerId = null;
      }

      if (open) {
        menu.hidden = false;
        menu.classList.add("is-active");
        syncToggleState(true);

        animationFrameId = window.requestAnimationFrame(function () {
          menu.classList.add("is-visible");
        });

        return;
      }

      menu.classList.remove("is-visible");
      syncToggleState(false);

      closeTimerId = window.setTimeout(function () {
        if (header.classList.contains("is-menu-open")) return;
        menu.hidden = true;
        menu.classList.remove("is-active");
        closeTimerId = null;
      }, transitionDuration);
    }

    toggles.forEach(function (button) {
      button.addEventListener("click", function () {
        setOpen(!header.classList.contains("is-menu-open"));
      });
    });

    if (overlay) {
      overlay.addEventListener("click", function () {
        setOpen(false);
      });
    }

    Array.prototype.slice.call(menu.querySelectorAll("a")).forEach(function (link) {
      link.addEventListener("click", function () {
        setOpen(false);
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        setOpen(false);
      }
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth >= 768) {
        setOpen(false);
      }
    });
  }

  function initScrollReveal() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll("[data-reveal]"));
    if (nodes.length === 0) return;

    nodes.forEach(function (node) {
      var delay = node.getAttribute("data-reveal-delay");
      if (delay) {
        node.style.transitionDelay = String(parseInt(delay, 10) / 1000) + "s";
      }
    });

    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (node) {
        node.classList.add("is-visible");
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.2 }
    );

    nodes.forEach(function (node) {
      observer.observe(node);
    });
  }

  function getInitialCartCount() {
    var badge = document.querySelector("[data-bn-cart-count]");
    if (!badge) return 0;

    var parsed = parseInt(badge.textContent, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  function setCartCount(count) {
    var normalizedCount = count < 0 ? 0 : count;

    Array.prototype.slice.call(document.querySelectorAll("[data-bn-cart-count]")).forEach(function (badge) {
      badge.textContent = String(normalizedCount);
    });

    try {
      window.sessionStorage.setItem("bn-cart-count", String(normalizedCount));
    } catch (error) {
      return;
    }
  }

  function initCartCountSync() {
    var initialCount = getInitialCartCount();

    setCartCount(initialCount);

    document.addEventListener("cart:update", function (event) {
      var detail = event.detail && event.detail.data ? event.detail.data : null;
      if (!detail) return;

      var nextCount = parseInt(detail.itemCount, 10);
      if (Number.isNaN(nextCount)) return;

      if (detail.source === "product-form-component") {
        setCartCount(getInitialCartCount() + nextCount);
        return;
      }

      setCartCount(nextCount);
    });
  }

  onReady(function () {
    toggleScrollState();
    initMobileMenu();
    initScrollReveal();
    initCartCountSync();
  });

  window.addEventListener("scroll", toggleScrollState, { passive: true });
})();
